export default "__VITE_ASSET__de4884cd__"